import { RouteConfig } from 'vue-router'
import { ideasRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'

export const ideas: RouteConfig[] = [
  {
    path: '/ideas',
    name: ideasRoutes.default,
    meta: {
      RedirectExternalUrl: 'https://ideas.gohighlevel.com/',
    },
    beforeEnter: requireAuth,
  },
]
